"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_tables_1 = require("prosemirror-tables");
var cloneDeep = require('lodash.clonedeep');
var cellWrapping = function ($pos) {
    for (var d = $pos.depth; d > 0; d--) {
        var role = $pos.node(d).type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell')
            return $pos.node(d);
    }
    return null;
};
exports.cellWrapping = cellWrapping;
var canSplitCell = function (view) {
    var sel = view.state.selection;
    var cellNode;
    if (!(sel instanceof prosemirror_tables_1.CellSelection)) {
        cellNode = cellWrapping(sel.$from);
        if (!cellNode)
            return false;
    }
    else {
        if (sel.$anchorCell.pos != sel.$headCell.pos)
            return false;
        cellNode = sel.$anchorCell.nodeAfter;
    }
    if (cellNode && cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) {
        return false;
    }
    return true;
};
exports.canSplitCell = canSplitCell;
/**
 * 动态改变表格右键的菜单
 * @param {view} EditorView
 * @param {data} TMenu[]
 */
var formatMenu = function (view, data) {
    var sel = view.state.selection;
    var defaultMenus = cloneDeep(data);
    var menus = defaultMenus.filter(function (menu) { return typeof menu === 'string' || menu.key !== 'mergeCells'; });
    if (sel instanceof prosemirror_tables_1.CellSelection && sel.ranges.length > 1) {
        menus = defaultMenus.filter(function (menu) { return typeof menu === 'string' || menu.key !== 'splitCell'; });
    }
    else {
        if (!canSplitCell(view)) {
            var index = menus.findIndex(function (menu) { return typeof menu !== 'string' && menu.key === 'splitCell'; });
            menus.splice(index, 2);
        }
        if (sel.from === sel.to) {
            menus = menus.map(function (values) {
                if (typeof values !== 'string' && (values.key === 'cut' || values.key === 'copy')) {
                    return __assign(__assign({}, values), { disable: true });
                }
                return values;
            });
        }
    }
    return menus;
};
exports.formatMenu = formatMenu;
/**
 * @param cursorRect
 * @param domRect
 */
var calculateMenuPosition = function (cursorRect, domRect) {
    var clientY = cursorRect.clientY, clientX = cursorRect.clientX;
    var width = domRect.width, height = domRect.height;
    var prefixTop = (document.scrollingElement && document.scrollingElement.scrollTop) || 0;
    var top = clientY + prefixTop, left = clientX;
    if (clientY + height > window.innerHeight) {
        var offsetTop = 10;
        top = prefixTop - height + window.innerHeight - offsetTop;
        if (top < 0)
            top = 0;
    }
    if (clientX + width > window.innerWidth) {
        left = window.innerWidth - width;
    }
    return {
        top: top,
        left: left
    };
};
exports.calculateMenuPosition = calculateMenuPosition;
//# sourceMappingURL=menu-helper.js.map